import { Typography } from "@mui/material";
import styles from "./CoreProctoringTimer.module.css";
import i18nPackage from "../../i18n/i18n";
import MicrophoneIcon from "../images/microphone.svg?react";
import CameraIcon from "../file/images/camera.svg?react";
import WebcamIcon from "../images/webcam.svg?react";
import ComputerIcon from "../images/computer.svg?react";

function secondsToTime(seconds: number) {
	const hoursTime = Math.floor(seconds / (60 * 60))
		.toString()
		.padStart(2, "0");
	const minutesTime = Math.floor((seconds % (60 * 60)) / 60)
		.toString()
		.padStart(2, "0");
	const secondsTime = Math.floor(seconds % 60)
		.toString()
		.padStart(2, "0");

	return { hours: hoursTime, minutes: minutesTime, seconds: secondsTime };
}

type TimerIconProps = {
	children: React.ReactNode;
	className?: string;
};

function TimerIcon({ children, className }: TimerIconProps) {
	return <div className={`${styles.iconContainer} ${className || ""}`}>{children}</div>;
}

type CoreProctoringTimerProps = {
	className?: string;
	timeMs: number;
	label?: React.ReactNode;
};

export default function CoreProctoringTimer({ timeMs, label, className }: CoreProctoringTimerProps) {
	const { hours, minutes, seconds } = secondsToTime(Math.floor(timeMs / 1000));
	return (
		<div className={`${styles.coreProctoringTimer} ${className || ""}`}>
			<div className={styles.timerContainer}>
				<Typography className={styles.timerLabel}>{label}</Typography>
				<div className={styles.timeCircle}>
					<Typography className={styles.timeText}>
						{i18nPackage.t("coreComponents.timer.timer", { hour: hours, min: minutes, sec: seconds })}
					</Typography>
				</div>
			</div>
			<TimerIcon className={styles.mic}>
				<MicrophoneIcon />
			</TimerIcon>
			<TimerIcon className={styles.camera}>
				<CameraIcon />
			</TimerIcon>
			<TimerIcon className={styles.webcam}>
				<WebcamIcon />
			</TimerIcon>
			<TimerIcon className={styles.computer}>
				<ComputerIcon />
			</TimerIcon>
		</div>
	);
}
